import React from 'react';
import { RootStore } from '../stores/root.store';
import { stores, StoresContext } from '../stores/stores';

export const useRootStore = (): RootStore =>
  React.useContext(StoresContext).rootStore;

export const useStore = <T extends keyof typeof stores.stores>(
  store: T
): typeof stores.stores[T] => React.useContext(StoresContext).stores[store];
